import { render, staticRenderFns } from "./CreateVehicleAssign.vue?vue&type=template&id=2eb68b0d"
import script from "./CreateVehicleAssign.vue?vue&type=script&lang=js"
export * from "./CreateVehicleAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports